import { render, staticRenderFns } from "./FrontCategoryShower.vue?vue&type=template&id=71bc22a4&lang=true&"
import script from "./FrontCategoryShower.vue?vue&type=script&lang=js&"
export * from "./FrontCategoryShower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports